import axios from 'axios';

export default async function sendMessage(threadId, newMessage) {
    console.log("Consultando Thread ID:", threadId);

    // Envia uma nova mensagem para a thread
    try {
        const sendMessageResponse = await axios.post(
          `https://api.openai.com/v1/threads/${threadId}/messages`, 
          {
                role: "user",
                content: newMessage, // Mensagem que será enviada
          },
          {
            headers: {
              'Authorization': `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
              'OpenAI-Beta': 'assistants=v2',
              "Content-Type": 'application/json'
            },
          }
        );

    } catch (error) {
        console.error("Erro ao processar a requisição:", error);
        throw error;
    }
}
